import React from 'react';
import { ShowButton, Datagrid, TextField, DateField } from 'react-admin';
import TList from '../../components/wrapper/TList';

const IdDocumentList = props => (
	<TList
		exporter={false}
		actions={null}
		sort={{ field: 'id', order: 'DESC' }}
		{...props}
	>
		<Datagrid>
			<ShowButton />
			<TextField source="id" sortByOrder="DESC" />
			<DateField source="creationDateTime" showTime />
			<TextField source="status" />
			<TextField source="originalFileName" />
			<TextField source="qualifier" />
		</Datagrid>
	</TList>
);

export default IdDocumentList;
